import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { branchesApi } from '@/lib/apiServices';
import { VendorProductGrid } from './VendorStorefront';
import StorefrontHero, { StorefrontLoading, StorefrontNotFound } from './StorefrontHero';
import '../marketplace.css';

export default function BranchStorefront() {
  const { branchId } = useParams();
  const [storefront, setStorefront] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    Promise.resolve().then(async () => {
      if (!branchId) {
        if (!cancelled) {
          setStorefront(null);
          setState('error');
        }
        return;
      }

      setState('loading');
      try {
        const { data, error } = await branchesApi.get(branchId);
        if (cancelled) return;
        setStorefront(data ?? null);
        setState(error || !data ? 'error' : 'ready');
      } catch {
        if (cancelled) return;
        setStorefront(null);
        setState('error');
      }
    });

    return () => { cancelled = true; };
  }, [branchId]);

  if (state === 'loading') return <StorefrontLoading label="شعبه" />;
  if (state === 'error' || !storefront) return <StorefrontNotFound label="شعبه" />;

  return (
    <main>
      <div className="storefront-back-wrap">
        <div className="container">
          <Link className="storefront-back" to="/marketplace">
            <i className="fas fa-arrow-right" aria-hidden="true" /> بازگشت به شعب و فروشندگان
          </Link>
        </div>
      </div>

      <StorefrontHero
        name={storefront.vendor_shop_name_fa || 'شعبه رسمی ایران چارسوق'}
        banner={storefront.vendor_banner_url}
        verified={storefront.is_verified}
        productCount={storefront.products?.length ?? 0}
        location={storefront.location}
        address={storefront.address}
        latitude={storefront.latitude}
        longitude={storefront.longitude}
      />

      <div className="container storefront-content">
        <VendorProductGrid products={storefront.products} emptyMessage="این شعبه هنوز محصولی ندارد." />
      </div>
    </main>
  );
}
